import React, { useState, useEffect } from "react";

import {
  Button,
  Dialog,
  Grid,
  Icon,
  Typography,
  Select,
  FormHelperText,
} from "@material-ui/core";

import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";

import DialogLoader from "../../../components/Loader/DialogLoader";
import RichTextEditor from "react-rte";
import {
  InputBaseField,
  SelectField,
  TextareaField,
} from "../../../components/InputField/InputField";
import {
  Label,
  DraggableComponent,
} from "../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../Services/APIService";
import { withSnackbar } from "../../../components/Message/Alert";
import useStyles from "./styles";
import {
  validateEmail,
  validatePhoneNumber,
  handleNegativeNumberWithDecimal,
  handleNumberKeyPress,
  isDigitsOnly,
} from "../../../../src/components/Common/Extensions";
import Logo from "../../../assets/img/Figger-foundation-logo.svg";
import Logo2 from "../../../assets/img/logo.svg";
import googleGif from "../../../assets/img/common/googleGif.gif";
import BBBGif from "../../../assets/img/common/bbbGif.gif";
import TwitterGif from "../../../assets/img/common/twitterGif.gif";
import TrustpilotGif from "../../../assets/img/common/trustpilotGif.gif";
import FiggersGif from "../../../assets/img/common/figgersGif.gif";
import FacebookGif from "../../../assets/img/common/facebookGif.gif";
import StarGif from "../../../assets/img/Top-Stars-Animation-.gif";

import EmailIcon from "../../../assets/img/email/email2-white.png";
import CallIcon from "../../../assets/img/email/call2-white.png";
import GlobIcon from "../../../assets/img/email/globe2-white.png";
import MapIcon from "../../../assets/img/email/map2-white.png";
import FreddieSign from "../../../assets/img/freddieSign.png";
import DonationBanner from "../../../assets/img/common/donateBanner1.jpg";
import DonationBanner2 from "../../../assets/img/email/donateBanner2.png";

import BackgroundLogo from "../../../assets/img/BGLogo.png";
import BackgroundLogo2 from "../../../assets/img/BGLogo2.png";
import PartnerLogo from "../../../assets/img/common/sponsorImg.jpg";
import footerLogo2 from "../../../assets/img/email/footer-img.jpg";
import HeaderTem4 from "../../../assets/img/email/header-img2.jpg";
import FacebookLogo from "../../../assets/img/icons/Facebook.png";
import LinkedinLogo from "../../../assets/img/icons/Linkedin.png";

import TwitterLogo from "../../../assets/img/icons/Twitter.png";

import InstaLogo from "../../../assets/img/icons/Insta.png";


import moment from "moment";

function SendRequest({
  dialogOpenClose,
  handleClose,
  handleSuccessClose,
  accountNumber,
  isPrepaid,
  editRecordId,
  ...props
}) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({});
  const { showMessage } = props;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value.trim() === "" && value !== "") {
      return;
    }

    const trimmedValue = value.replace("/s{2,}/g", "");

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;

    if (e.target.value != "") {
      const re = /^[0-9\b]+$/;
      e.target.value = e.target.value
        .replace(" ", "")
        .replace("(", "")
        .replace(")", "")
        .replace("-", "");
      const { name, value } = e.target;
      if (e.target.value === "" || re.test(e.target.value)) {
        var cleaned = ("" + e.target.value).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = match[1] ? "+1 " : "",
            number = [
              intlCode,
              "(",
              match[2],
              ") ",
              match[3],
              "-",
              match[4],
            ].join("");

          setState((prevState) => ({
            ...prevState,
            [name]: number,
          }));
          return;
        }
        setState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        if (!re.test(e.target.value)) {
          e.preventDefault();
        }
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const toolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "strikethrough", style: "STRIKETHROUGH" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
      { label: "Blockquote", style: "blockquote" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Style", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
  };

  const [templateState, setTemplateState] = useState("");

  const [emailTemp, setEmailTemp] = useState([]);
  const socialIcons = [
    { src: FacebookLogo, url: "https://www.facebook.com" },
    { src: InstaLogo, url: "https://www.instagram.com" },
    { src: TwitterLogo, url: "https://www.twitter.com" },
    { src: LinkedinLogo, url: "https://www.linkedin.com" },
  ];
  const [donationMailTemp, setDonationMailTemp] = useState([
    {
      label: "Template 1",
      value: "Template1",
    },
    {
      label: "Template 2",
      value: "Template2",
    },
    {
      label: "Template 3",
      value: "Template3",
    },
    {
      label: "Template 4",
      value: "Template4",
    },
    {
        label: "Template 5",
        value: "Template5",
    },
    {
        label: "Template 6",
        value: "Template6",
    }
  ]);

  const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(0);

  const regex = /(<([^>]+)>)/gi;
  const regexSpaces = /((&nbsp;))*/gim;

  const MAX_EDITOR_LENGTH = 2000;

  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createValueFromString("", "html")
  );

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [lstStates] = useState([
    { label: "Please Select State", value: "" },
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "District of Columbia", value: "DC" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho	", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "Va.WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" },
  ]);

  const handleZipCodeChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleEditorChange = (editorValue) => {
    const editorDetail = editorValue.toString("html").replace(regex, "");

    if (editorDetail && editorDetail.length > MAX_EDITOR_LENGTH) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEditorMaxValue: true,
      }));
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEditorMaxValue: false,
      }));
    }
    setEDITOR_CHAR_LENGTH(editorDetail.length);

    setEditorValue(editorValue);

    setState((prevState) => ({
      ...prevState,
      message: editorDetail,
    }));
  };

  const [errorMessages, setErrorMessages] = useState({});
  const changeTemplate = (e) => {
    const { name, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      templateId: value,
    }));
  };

  const Validate = (errorList) => {
    if (!state.firstName) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorFirstName: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorFirstName: false,
      }));
    }

    if (!state.lastName) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorLastName: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorLastName: false,
      }));
    }

    if (!state.emailAddress || !validateEmail(state.emailAddress)) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEmailAddress: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorEmailAddress: false,
      }));
    }

    if (!state.phone || !validatePhoneNumber(state.phone)) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorPhone: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorPhone: false,
      }));
    }
    if (!state.address) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorAddress: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorAddress: false,
      }));
    }

    if (!state.city) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorCity: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorCity: false,
      }));
    }

    if (!state.state) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorState: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorState: false,
      }));
    }

    if (!state.zipcode) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorZipCode: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorZipCode: false,
      }));
    }
    if (!state.amount) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorAmount: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorAmount: false,
      }));
    }

    if (!state.templateId) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorTemplate: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorTemplate: false,
      }));
    }

    if (!state.message) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorMessage: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorMessage: false,
      }));
    }
  };
  const addNew = () => {
    //resetErrors();
    let errorList = [];
    Validate(errorList);
    if (errorList.length < 1) {
      setIsLoading(true);
      let method = "payments/addDonationRequest";
      state.templateId = state.templateId;
      state.message = editorValue.toString("html");
        PostDataAPI(method, state, true).then((result) => {
            setIsLoading(false);
            if (result.success) {
              if (result.data) {
                
                handleSuccessClose("Donation request sent successfully");
                // sendEmail();
              } else {
                showMessage(
                  "Error",
                  "Error sending donation request, please contact administrator",
                  "error",
                  3000
                );
              }
            } else {
              showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
      });
    }
  };
  let loadDonationRequest = (requestId) => {
    setIsLoading(true);
    let params = {
      requestId: requestId,
      firstName: "",
      lastName: "",
      emailAddress: "",
      phone: "",
    };
    PostDataAPI("payments/getDonationById", params, true).then((result) => {
      if (result.success && result.data) {
        setState(result.data);
        if (result.data.message) {
          setEditorValue(
            RichTextEditor.createValueFromString(result.data.message, "html")
          );
        } else {
          setEditorValue(RichTextEditor.createValueFromString("", "html"));
        }
      } else {
        showMessage("Error", result.message, "error", 3000);
      }
      setIsLoading(false);
    });
  };
  useEffect(() => {
    if (editRecordId && editRecordId > 0) {
      loadDonationRequest(editRecordId);
    } else {
      setState((prevState) => ({
        ...prevState,
        templateId: "Template1",
      }));
    }
  }, []);

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpenClose}
      PaperComponent={DraggableComponent}
      maxWidth="lg"
      {...props}
    >
      <div className={classes.dialogContent}>
        <div className={classes.box}>
          <div className={classes.header} id="draggable-dialog-title">
            <Typography className={classes.title}>Donation Request</Typography>

            <Icon
              className={classes.closeIcon}
              onClick={handleClose}
              color="primary"
            >
              <CloseIcon />
            </Icon>
          </div>

          {isLoading ? <DialogLoader></DialogLoader> : ""}
          <Scrollbars autoHeight autoHeightMax={550}>
            <div className={classes.content}>
              <Grid container spacing={2}>
                <Grid item sm={6} md={6} lg={6} xl={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label title="First Name" size={12} mandatory={true} />
                        <InputBaseField
                          name="firstName"
                          value={state.firstName}
                          onChange={handleChange}
                          placeholder="First Name"
                          type="text"
                          MaxLength={19}
                        />
                        {errorMessages.errorFirstName &&
                        (!state.firstName || state?.firstName.length < 19) ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter first name
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label title="Last Name" size={12} mandatory={true} />
                        <InputBaseField
                          name="lastName"
                          value={state.lastName}
                          onChange={handleChange}
                          placeholder="Last Name"
                          type="text"
                          MaxLength={19}
                        />
                        {errorMessages.errorLastName &&
                        (!state.lastName || state?.lastName.length < 19) ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter last name
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label
                          title="Email Address"
                          size={12}
                          mandatory={true}
                        />

                        <InputBaseField
                          name="emailAddress"
                          value={state.emailAddress}
                          onChange={handleChange}
                          placeholder="Email Address"
                          type="text"
                          MaxLength={30}
                        />
                        {errorMessages.errorEmailAddress &&
                        (!state.emailAddress ||
                          state?.emailAddress.length < 15 ||
                          !validateEmail(state.emailAddress)) ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter a valid email
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label title="Phone #" size={12} mandatory={true} />
                        <InputBaseField
                          name="phone"
                          value={state.phone}
                          onChange={handlePhoneChange}
                          placeholder="Phone #"
                          type="text"
                          MaxLength={14}
                        />
                        {errorMessages.errorPhone &&
                        (!state.phone || state?.phone.length < 14) ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter a valid phone number
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Label size={12} title="Address" mandatory={true} />
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <InputBaseField
                        id="address"
                        name="address"
                        type="text"
                        value={state.address}
                        onChange={handleChange}
                        placeholder="Address"
                        IsDisabled={false}
                        MaxLength={80}
                      />
                      {errorMessages.errorAddress && !state.address ? (
                        <FormHelperText style={{ color: "red" }}>
                          Please enter address
                        </FormHelperText>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Label size={12} title="City" mandatory={true} />
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <InputBaseField
                          id="city"
                          name="city"
                          type="text"
                          value={state.city}
                          onChange={handleChange}
                          placeholder="City"
                          IsDisabled={false}
                          MaxLength={50}
                        />
                        {errorMessages.errorCity && !state.city ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter city
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Label size={12} title="State" mandatory={true} />
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Select
                          size="small"
                          native
                          name="state"
                          value={state?.state}
                          onChange={handleSelectChange}
                          placeholder="Select"
                          label="Select"
                          className={classes.selectBaseInput}
                        >
                          {lstStates.map((option) => (
                            <option value={option.value}>{option.label}</option>
                          ))}
                        </Select>
                        {errorMessages.errorState && !state.state ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please select state
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Label size={12} title="Zip code" mandatory={true} />
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <InputBaseField
                          id="zipCode"
                          name="zipcode"
                          type="text"
                          value={state.zipcode}
                          onChange={handleZipCodeChange}
                          MaxLength={7}
                          onKeyPress={(e) => handleNumberKeyPress(e)}
                          placeholder="Zip code"
                          IsDisabled={false}
                        />
                        {errorMessages.errorZipCode && !state.zipcode ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter zip code
                          </FormHelperText>
                        ) : (
                          ""
                        )}

                        {errorMessages.errorInvalidZipCode &&
                        state.zipcode &&
                        !isDigitsOnly(state.zipcode) ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter valid zip code
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label title="Amount $" size={12} mandatory={true} />
                        <Grid xl={12} md={12} sm={12} lg={12}>
                          <InputBaseField
                            id="cash"
                            name="amount"
                            value={state.amount}
                            type="text"
                            placeholder="Amount"
                            MaxLength="5"
                            onChange={handleChange}
                            onKeyPress={(e) =>
                              handleNegativeNumberWithDecimal(e)
                            }
                          />
                          {errorMessages.errorAmount && !state.amount ? (
                            <FormHelperText style={{ color: "red" }}>
                              Please enter amount
                            </FormHelperText>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid row>
                        <Label title="Template" size={12} mandatory={true} />
                        {/*<SelectField options={donationMailTemp}*/}
                        {/*    value={state.templateId}*/}
                        {/*    onChange={changeTemplate}*/}
                        {/*    name="templateId"*/}
                        {/*    defaultValue="Template1"*/}

                        {/*/>*/}
                        {/*{errorMessages.errorTemplate && !state.templateId ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*    Please select template*/}
                        {/*</FormHelperText>) : ('')}*/}
                        <Select
                          size="small"
                          native
                          name="templateId"
                          value={state?.templateId}
                          onChange={handleSelectChange}
                          placeholder="Select"
                          label="Select"
                          className={classes.selectBaseInput}
                        >
                          {donationMailTemp.map((option) => (
                            <option value={option.value}>{option.label}</option>
                          ))}
                        </Select>
                        {errorMessages.errorTemplate && !state.templateId ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please select template
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} className={classes.textEditor}>
                    <Grid item sm={12} md={12} lg={12} xl={12}>
                      <Grid row>
                        <Label title="Message" size={12} mandatory={true} />
                        <RichTextEditor
                          value={editorValue}
                          onChange={handleEditorChange}
                          className={classes.note}
                          // value={state.message}
                          placeholder="Message goes here..."
                          toolbarConfig={toolbarConfig}
                        ></RichTextEditor>

                        {errorMessages.errorMessage && !state.message ? (
                          <FormHelperText style={{ color: "red" }}>
                            Please enter a message
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item sm={6} md={6} lg={6} xl={6}>
                  <div className={classes.templateContainer}>
                    {state.templateId == "Template1" ||
                    state.templateId == "Template2" ||
                    state.templateId == "Template3" ||
                    state.templateId == "Template6" ? (
                      <div
                        className={"tempHeader"}
                        style={{
                          background: state.templateId === "Template6" ? "#df614a" : "rgb(49 49 49)",
                        }}
                      >
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12}>
                            <img src={Logo} />
                          </Grid>
                        </Grid>
                      </div>
                    ) : state.templateId == "Template4" ||
                      state.templateId == "Template5" ? (
                      <Grid container>
                        <Grid item lg={12} md={12} sm={12}>
                          <img src={HeaderTem4} style={{ width: "-webkit-fill-available" }} />
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}

                    <div className={"tempContent"}>
                      <h1>
                        {state.firstName} {state.lastName}
                      </h1>

                      <Grid container>
                        <Grid item md={8} lg={8}>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: editorValue.toString("html"),
                            }}
                          ></p>
                        </Grid>
                      </Grid>

                      <div>
                        <p>Sincerely </p>
                        <img src={FreddieSign} />
                        <p>
                          {" "}
                          <b>FREDDIE FIGGERS</b>
                        </p>
                        <p>Board Chairman of The Figgers Foundation Inc.</p>
                      </div>
                    </div>
                    
                    {state.templateId == "Template1" || state.templateId == "Template4" ? (
                      <div className={classes.donateSection}>
                        <h3> Click here to Donate! </h3>
                        <Button className={classes.greenBtn}>Donate</Button>
                      </div>
                    ) : state.templateId == "Template2" ? (
                      <Grid container>
                        <Grid lg={12} md={12} sm={12}>
                          <img src={DonationBanner} width="100%" />
                        </Grid>
                      </Grid>
                    ) : state.templateId == "Template3" || state.templateId == "Template6" ? (
                      <Grid
                        container
                        className={state.templateId == "Template3" ? classes.donateSectionTem3 : classes.donateSectionTem6}
                        style={{
                          backgroundImage: state.templateId == "Template3" ? "URL(" + BackgroundLogo + ")" : "URL(" + BackgroundLogo2 + ")",
                        }}
                      >
                        <Grid lg={6} md={6} sm={6}>
                          {/* <img src={BackgroundLogo} width="100%" /> */}
                        </Grid>
                        <Grid>
                          <div>
                            <h3>
                              <span>Click here</span> to Donate!{" "}
                            </h3>
                            <Button>Donate</Button>
                          </div>
                        </Grid>
                      </Grid>
                    ) : state.templateId == "Template5" ? (
                        <Grid container>
                          <Grid lg={12} md={12} sm={12}>
                            <img src={DonationBanner2} width="100%" />
                          </Grid>
                        </Grid>
                      ) :(
                      ""
                    )}
                    <Grid container>
                      <Grid lg={12} md={12} sm={12}>
                        <img src={PartnerLogo} width="100%" />
                      </Grid>
                    </Grid>
                    {state.templateId == "Template1" ||
                    state.templateId == "Template2" ||
                    state.templateId == "Template3" ||
                    state.templateId == "Template6"  ? (
                      <Grid>
                        <Grid container className={classes.emailFooter}>
                          <Grid container>
                            <img
                              src={Logo2}
                              width="170px"
                              style={{ padding: "10px 0" }}
                            />
                          </Grid>

                          <Grid container>
                            <Grid lg={6} md={6} sm={6}>
                              <h4>The Figgers Foundation.</h4>
                              <p>
                                The Figgers Foundation's aim is to provide
                                essential resources that will help to propel
                                those in need toward a better tomorrow.
                              </p>
                            </Grid>

                            <Grid lg={6} md={6} sm={6}>
                              <p>
                                {" "}
                                <img
                                  src="https://figgersfoundation.org/ff-email-assets/icons/map2.png"
                                  alt="Map Icon"
                                  height="14"
                                  width="14"
                                />
                                3810 Inverrary Boulevard, Suite 401 Fort
                                Lauderdale, Florida 33319
                              </p>

                              <p>
                                {" "}
                                <img
                                  src="https://figgersfoundation.org/ff-email-assets/icons/call2.png"
                                  alt="Map Icon"
                                  height="14"
                                  width="14"
                                />
                                1-800-391-2803
                              </p>

                              <p>
                                {" "}
                                <img
                                  src="https://figgersfoundation.org/ff-email-assets/icons/email2.png"
                                  alt="Map Icon"
                                  height="14"
                                  width="14"
                                />
                                info@FiggersFoundation.org
                              </p>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : state.templateId == "Template4" || state.templateId == "Template5"? (
                      <Grid>
                        <Grid container>
                          <img
                            src={footerLogo2}
                            style={{ width: "inherit", marginTop: "15px" }}
                          />
                          <Grid lg={12} md={12} sm={12}>
                            <div className={classes.templateFooter2}>
                              <Grid container>
                                <Grid item lg={4} md={4} sm={4}>
                                  <p>
                                    {" "}
                                    <img src={CallIcon} /> 1-800-391-2803{" "}
                                  </p>
                                </Grid>
                                <Grid item lg={4} md={4} sm={4}>
                                  <p>
                                    {" "}
                                    <img src={EmailIcon} />{" "}
                                    Info@FiggersFoundation.org{" "}
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  lg={4}
                                  md={4}
                                  sm={4}
                                  style={{ textAlign: "right" }}
                                >
                                  <p>
                                    {" "}
                                    <img src={GlobIcon} /> The Figgers
                                    Foundation
                                  </p>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12}>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      margin: "5px",
                                    }}
                                  >
                                    {" "}
                                    <img src={MapIcon} /> 14508 Lincoln
                                    Boulevard. Suite: 212, Fort Miami, Florida
                                    33176
                                  </p>
                                </Grid>
                              </Grid>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                        <Grid container>
                        <Grid lg={12} md={12} sm={12} className={classes.SocialIcons} style={{
                          background: state.templateId === "Template6" ? "#df614a" : "rgb(49 49 49)",
                        }}>
                          {socialIcons.map((icon, index) => (
                            <a key={index} href={icon.url} target="_blank" rel="noopener noreferrer">
                              <img src={icon.src} alt={`Social Icon ${index + 1}`} className={classes.SocialLogo} />
                            </a>
                          ))}
                        </Grid>
                      </Grid>

                  </div>
                </Grid>
              </Grid>
            </div>
          </Scrollbars>
          <div className={classes.footer}>
            <div className={classes.footerRight}>
              <Button className={classes.backBtn} onClick={handleClose}>
                Close
              </Button>
              <Button className={classes.changeBtn} onClick={addNew}>
                Send
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default withSnackbar(SendRequest);
